import { HANDLER_REQUEST } from '@shared/constants/exportations';
import { RestInfraestructureService } from '@shared/services/infraestructure/rest-infraestructure.service';
import { Provider } from '@angular/core';

/**
 * Moved from SharedModule
 */
export const REST_INFRASTRUCTURE_PROVIDERS: Provider[] = [
  { provide: HANDLER_REQUEST, useClass: RestInfraestructureService },
];
